class RotatingHeadingComponent extends HTMLElement {
  #observer = new MutationObserver(() => this.#fillIfEmpty());
  #chosenText = null;

  connectedCallback() {
    this.#fillIfEmpty();

    const target = this.querySelector('[ref="rotatingHeadingText"]');
    if (target) {
      this.#observer.observe(target, { childList: true, characterData: true, subtree: true });
    }
  }

  disconnectedCallback() {
    this.#observer.disconnect();
  }

  #fillIfEmpty() {
    const target = this.querySelector('[ref="rotatingHeadingText"]');
    if (!target) return;
    if (target.textContent.trim() !== '') return;

    if (this.#chosenText === null) {
      const raw = this.dataset.options || '';
      const options = raw.split('|||').filter(Boolean);
      if (options.length === 0) return;
      this.#chosenText = options[Math.floor(Math.random() * options.length)];
    }

    // Setting textContent inside the observer callback would normally trigger
    // another mutation and loop forever, so pause observing while we write.
    this.#observer.disconnect();
    target.textContent = this.#chosenText;
    this.#observer.observe(target, { childList: true, characterData: true, subtree: true });
  }
}

if (!customElements.get('rotating-heading-component')) {
  customElements.define('rotating-heading-component', RotatingHeadingComponent);
}
